import { useContext } from 'react';

import MixPanelHelper from 'helpers/mixpanel';
import { RootContext } from 'pages/leads/components/leads-provider';

export default function useLeadsMixPanel() {
  const rootContext = useContext(RootContext);

  const { leadIdCookie, leadProfileCookie } = rootContext;

  const userData = {
    id: leadIdCookie || leadProfileCookie?.id,
    ...leadProfileCookie,
  };

  return MixPanelHelper(userData)?.getInstance();
}
